import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const publicGet = async (url, params) => (await axios.get(API + url, { params })).data;
export const publicPost = async (url, data) => (await axios.post(API + url, data)).data;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, params) => {
      const token = await getToken();
      const res = await axios({ method, url: API + url, data, params, headers: token ? { Authorization: `Bearer ${token}` } : {} });
      return res.data;
    },
    [getToken]
  );
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Si è verificato un errore, riprova.";
};

export const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", useGrouping: "always" }).format(Number(n) || 0);
export const num = (n) => new Intl.NumberFormat("it-IT", { useGrouping: "always" }).format(Number(n) || 0);
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export const redeemValue = (points, rate) => Math.floor(points * rate * 100) / 100;

export const STATUS = {
  bronze: { label: "Bronze", color: "#CD7F32", card: "from-[#2A1B12] via-[#1A120B] to-[#0D0805]", ring: "border-[#CD7F32]/40" },
  gold: { label: "Gold", color: "#F59E0B", card: "from-[#2C220B] via-[#1D1606] to-[#0F0B03]", ring: "border-[#F59E0B]/50" },
  diamond: { label: "Diamond", color: "#38BDF8", card: "from-[#0B1E2C] via-[#06121C] to-[#03090F]", ring: "border-[#38BDF8]/50" },
};

export const ORDER_STATUS = {
  in_attesa_bonifico: { label: "In attesa di bonifico", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  pagato: { label: "Pagato", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  acquistato: { label: "Acquistato", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  in_preparazione: { label: "In preparazione", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  spedito: { label: "Spedito", cls: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30" },
  pronto_ritiro: { label: "Pronto per il ritiro", cls: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30" },
  consegnato: { label: "Consegnato", cls: "bg-emerald-500/15 text-emerald-200 border-emerald-500/30" },
  annullato: { label: "Annullato", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
  pending: { label: "In attesa di approvazione", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  approved: { label: "Approvato", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  rejected: { label: "Rifiutato", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
  suspended: { label: "Sospeso", cls: "bg-zinc-500/20 text-zinc-300 border-zinc-500/30" },
};
